import { UserApiFactory } from '@eloomi/eloomi-learning-persona-client/1.0';

import { authorizeClient } from '@/api/authorize-client';
import { extractAxiosData } from '@/common/services/extract-axios-data';

const userClient = authorizeClient(UserApiFactory);

export function getUserCoursesSkills() {
    return userClient.getUserCourseSkills().then(extractAxiosData);
}
